import { defineSlotRecipe } from '@chakra-ui/react';

export const messageBubbleRecipe = defineSlotRecipe({
	slots: [ 'root', 'message', 'timestamp' ],

	base: {
		root: {},

		message: {
			maxW:       '50ch',
			px:         4,
			py:         4,
			rounded:    'lg',
			textStyle:  'body',
			whiteSpace: 'pre-wrap',
		},
		timestamp: {
			color:     'gray.100',
			mt:        2,
			textStyle: 'caption',
		},
	},
	variants: {
		sender: {
			me: {
				root:      { justifyContent: 'flex-end' },
				timestamp: { textAlign: 'right' },

				message: {
					bg:    'primary.50',
					color: 'text',
				},
			},
			them: {
				root: { justifyContent: 'flex-start' },

				message: {
					bg:    'secondary.100',
					color: 'white',
				},
			},
		},
	},
});
